import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
} from '@mui/material';
import Modal from '@mui/material/Modal';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { EReligion } from '../../../../shared/enums/user/EReligion';
import { ERole } from '../../../../shared/enums/user/ERole';
import { ETheme } from '../../../../shared/enums/user/ETheme';
import { IPagination } from '../../../../shared/interfaces/shared/IPagination';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../shared/mui/palettes';
import { RootState } from '../../../../store/store';

interface IProps {
  pagination: IEmployeeFilter;
  changeFilterHandler: (name: string, value: string) => void;
}
export interface IEmployeeFilter extends IPagination {
  firstName?: string;
  lastName?: string;
  email?: string;
  religion?: EReligion;
}
const EmployeeFilters: React.FC<IProps> = ({
  changeFilterHandler,
  pagination,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { theme, role } = useSelector(
    (state: RootState) => state.auth.userData,
  ) as IUser;
  const isNormalUser = role === ERole.USER;

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Box>
      <Button
        variant={'contained'}
        color={'secondary'}
        onClick={() => setOpen(true)}
      >
        <FilterAltOffOutlinedIcon />
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={'MuiModalBody'}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: { xs: '80%', lg: '30%' },
            justifyContent: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              paddingBottom: '10px',
              borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
            }}
          >
            <Typography id="modal-modal-title" variant="h6">
              {t('general.filterUsers')}
            </Typography>
          </Box>
          <Box sx={{ marginTop: '20px', marginBottom: '20px' }}>
            <TextField
              onChange={(e) => {
                changeFilterHandler('firstName', e.target.value);
              }}
              label={t('general.searchByName')}
              defaultValue={pagination?.firstName}
              sx={{ width: '100%' }}
            />
            <TextField
              onChange={(e) => {
                changeFilterHandler('email', e.target.value);
              }}
              defaultValue={pagination?.email}
              label={t('general.searchByEmail')}
              sx={{ width: '100%', marginTop: '20px' }}
            />
            {!isNormalUser && (
              <FormControl fullWidth sx={{ marginTop: '20px' }}>
                <InputLabel>{t('general.searchByReligion')}</InputLabel>
                <Select
                  labelId={`user-label`}
                  id={`user-select`}
                  defaultValue={pagination?.religion}
                  label={t('general.searchByReligion')}
                  onChange={(e) => {
                    changeFilterHandler('religion', e.target.value);
                  }}
                >
                  {Object.values(EReligion)
                    // @ts-ignore
                    ?.concat(undefined)
                    ?.map((religion) => {
                      return (
                        <MenuItem key={religion} value={religion}>
                          {t(`religion.${religion}`)}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            )}
          </Box>
          <div>
            <Button
              variant={'contained'}
              color={'secondary'}
              onClick={handleClose}
              sx={{ marginRight: '10px' }}
            >
              {t('button.cancel')}
            </Button>
          </div>
        </Box>
      </Modal>
    </Box>
  );
};

export default EmployeeFilters;
